function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { __RouterContext as RouterContext } from 'react-router';
import { Link } from 'react-router-dom';

class RouterLink extends Component {
  render() {
    const _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          selected = _this$props.selected,
          expanded = _this$props.expanded,
          value = _this$props.value,
          disabled = _this$props.disabled,
          haspopup = _this$props.haspopup,
          target = _this$props.target,
          onClick = _this$props.onClick,
          onToggle = _this$props.onToggle,
          tabindex = _this$props.tabindex,
          controls = _this$props.controls;
    const url = this.props.to || this.props.url;
    const external = url.startsWith('//') || url.startsWith('http://') || url.startsWith('https://');

    if (!external && url && this.context && this.context.history) {
      return React.createElement(Link, {
        to: url,
        className: className,
        style: style,
        onClick: onClick,
        target: target,
        tabindex: tabindex,
        "aria-controls": controls,
        "aria-haspopup": haspopup,
        "aria-selected": selected,
        "aria-expanded": expanded
      }, this.props.children);
    }

    if (url) {
      return React.createElement("a", {
        href: url,
        className: className,
        style: style,
        onClick: onClick,
        target: target,
        tabindex: tabindex,
        "aria-controls": controls,
        "aria-haspopup": haspopup,
        "aria-selected": selected,
        "aria-expanded": expanded
      }, this.props.children);
    }

    return React.createElement("div", {
      className: className,
      style: style,
      onClick: onClick,
      onToggle: onToggle,
      value: value,
      disabled: disabled,
      tabindex: tabindex,
      "aria-controls": controls,
      "aria-haspopup": haspopup,
      "aria-selected": selected,
      "aria-expanded": expanded
    }, this.props.children);
  }

}

_defineProperty(RouterLink, "contextType", RouterContext);

export default RouterLink;